<template>
<div class="flex w-full vx-row no-gutter justify-center">
   <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="동영상을 시청하세요." icon-pack="feather" icon="icon-info"></vs-list-header>
      </vs-list>

      <div>
        <video ref="videoPlayer" 
          controls 
          width="100%"
          v-on:ended="videoFinish" 
          controlsList="nodownload">
            Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
      
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" ></top-button-bar>    
  </div>  
  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0
    }
  },
  watch: {
  },
  computed: {
    videoPlayer () {
      return this.$refs.videoPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    onReload () {
      this.videoPlayer.pause()
      this.contentIndex = 0
      this.startAlert()
    },
    onStart () {
      console.log(this.content)
      this.videoPlayer.src = this.content.video
      this.videoPlayer.play()
    },
    videoFinish () {
      if (this.contentIndex < (this.contentsLen - 1)) {
        this.contentIndex++
        this.videoPlayer.src = this.content.audio
        this.videoPlayer.play()
      } else {
        this.onComplete()   
      }
    },
    acceptAlert () {
      this.onStart()
    },
    startAlert () {
      this.startStudyDlg('동영상을 시청하세요.')
    }    
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        video: this.$buildVideoPath(this.sourceContent.contentCode)
      } 
      this.contentList.push(content)
    }
    
    this.contentsLen = this.contentList.length
    this.startAlert()
  }
}

</script>

